import {useTheme} from '@primer/react-brand/esm'
import {useId} from 'react'

import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'

import {Product} from '../../Product/Product'
import {useHeroSequencePlayback} from './use-hero-sequence-playback'
import type {HeroSequenceProps} from './types'

import Styles from './HeroSequence.module.css'

export type {HeroSequenceHandle, HeroSequenceProps} from './types'

export const defaultProps: Partial<HeroSequenceProps> = {}

export const HeroSequence = (props: HeroSequenceProps) => {
  const initializedProps: HeroSequenceProps = {...defaultProps, ...props}
  const {labelledBy, chaptersAltDesc, video, ...playbackProps} = initializedProps
  const {currentChapterIndex} = playbackProps

  const descriptionId = useId()
  const {colorMode} = useTheme()
  const prefersReducedMotion = usePrefersReducedMotion()

  const videoUrl = colorMode === 'dark' ? video?.url.dark || video?.url.light : video?.url.light

  const {videoRef, reportPlayback, handleError} = useHeroSequencePlayback({
    ...playbackProps,
    videoUrl,
    chapterTimestamps: video?.chapterTimestamps,
    onActionChange: video?.onActionChange,
    prefersReducedMotion,
  })

  return (
    <div className={Styles['HeroSequence']}>
      <Product
        className={Styles.HeroSequence__product}
        theme={colorMode}
        minPadding="var(--base-size-64)"
        backgroundProps={{hasCornerDots: true}}
        mediaPosition="center-left"
        productUI={{
          className: Styles.HeroSequence__frame,
          shadowColor: 'green',
          shadowPosition: 'left-bottom',
        }}
      >
        <div className={Styles.HeroSequence__content}>
          <span id={descriptionId} hidden>
            {chaptersAltDesc[currentChapterIndex]}
          </span>
          {videoUrl && (
            <video
              className={Styles.HeroSequence__video}
              ref={videoRef}
              src={videoUrl}
              aria-labelledby={labelledBy}
              aria-describedby={descriptionId}
              muted
              playsInline
              preload="metadata"
              onTimeUpdate={reportPlayback}
              onPlay={reportPlayback}
              onPlaying={reportPlayback}
              onPause={reportPlayback}
              onWaiting={reportPlayback}
              onSeeking={reportPlayback}
              onSeeked={reportPlayback}
              onEnded={reportPlayback}
              onError={handleError}
            />
          )}
          {/* TODO: TBC, add JSON animation player component when not using a video? */}
        </div>
      </Product>
    </div>
  )
}
